/* eslint-disable linebreak-style */
import { MigrationSection } from './MigrationSection';

type Link = {
  text: string; url: string;
}

type PostMigrationNoticeProps = {
  platform: string;
  links?: Link[] | null;
  title?: string | null;
};

export function PostMigrationNotice({ platform, title, links }: Readonly<PostMigrationNoticeProps>) {
  switch (platform) {
  case 'combined':
    title = 'We’ve migrated your Benefits Administration Platforms!';
    links = [
      {
        text: 'Access Your New Flores Benefits Administration Portal',
        url: 'https://app.wealthcareadmin.com/',
      },
      {
        text: 'Access Your New Flores COBRA and Direct Billing Portal',
        url: 'https://floreshr.wealthcareemployer.com',
      }];
    break;
  case 'cdh':
    title = 'We’ve migrated your Benefits Administration Platform!';
    links = [
      {
        text: 'Access Your New Flores Benefits Administration Portal',
        url: 'https://app.wealthcareadmin.com/',
      }];
    break;
  case 'cobra':
    title = 'We’ve migrated your COBRA and Direct Billing Platform!';
    links = [
      {
        text: 'Access Your New Flores COBRA and Direct Billing Portal',
        url: 'https://floreshr.wealthcareemployer.com',
      }];
    break;

  default:
    break;
  }

  return (
    <MigrationSection
      body={[
        {
          title: title,
          links: links,
        },
        {
          subtext: 'Your New Platform Benefits',
          content: (
            <ul>
              <li>Comprehensive administration tools with improved usability</li>
              <li>Faster processing of account requests and notifications</li>
              <li>Streamlined self-service features</li>
            </ul>
          ),
        },
        {
          subtext: 'Moving to Your New Platform',
          content: (
            <ul>
              <li>We sent an email with your registration information to access the new website</li>
              <li>You can register using your existing email address</li>
              <li>All current plan and participant data is available on the new platform</li>
            </ul>
          ),
        },
        {
          subtext: 'Next Steps for You and Your Participants',
          content: (
            <ul>
              <li>Please begin using the new site(s) for all your administration activities</li>
              <li>This site will remain for a period but will display only historical data</li>
              <li>Your participants have received registration messages, please encourage them to sign up for the new
                  member experience!
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
